<template>
  <!-- <container> -->
      <!-- <div @click="sendwallpost('Мой текст сообщения');">отправить</div> -->
      <!-- <div id="vk_post_-70561071_28109"></div> -->
      <div id="vk_groups"></div>
    <!-- </container> -->
</template>
<script>

import VK from 'vk-openapi';
export default {
  data() {
    return {
      // loading: false,
      // walls: null,
      // error: null,
    };
  },
  created() {
    this.function1();
    // this.function2();
    this.function3();
  },

  methods: {
    // initVK() {
    //   VK.init({
    //     apiId: 	7798778 // id созданного вами приложения вконтакте 
    //     // 7798778
    //   });
    // }, 

    //  sendwallpost(mydata) {
    //     VK.api("wall.post", {
    //       // 553591004
    //         owner_id: '553591004',
    //         message: mydata,
    //         v: '5.130'
    //     }, function (data) {
    //       console.log(data);
    //     });

    //  }
  
 
    
    function1 () { 
      let d=document;
      let s='script';
      let id='vk_openapi_js'

      var js, fjs = d.getElementsByTagName(s)[0]; 
      if (d.getElementById(id)) return; 
      js = d.createElement(s); 
      js.id = id; 
      js.src = "https://vk.com/js/api/openapi.js?168"; 
      fjs.parentNode.insertBefore(js, fjs); 
    },

    // function2() {
    //   // if (!window.VK || !VK.Widgets || !VK.Widgets.Post || !VK.Widgets.Post('vk_post_1_45616', 1, 45616, 'Ysk5atBjpQ9NeJQJAZepivs0LF9v')) setTimeout(arguments.callee, 50)
    //   if (!window.VK || !VK.Widgets || !VK.Widgets.Post || !VK.Widgets.Post('vk_post_-70561071_28109', -70561071, 28109, 'JGXJ7F7dUN0YoBgycN0mo7NZDJhB')) setTimeout(arguments.callee, 50)
    // },


     function3() {
       try {
        if (!window.VK || !VK.Widgets || !VK.Widgets.Group || !VK.Widgets.Group("vk_groups", {mode: 4, wide: 1, height: "600", width: "auto" }, 70561071)) setTimeout(arguments.callee, 50)
       } catch (error) {
         console.log(error);
       }
    },













  }
}
</script>

